import React, { useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContactUs from './ContactUs';

const ReserveNow = ({ selectedModules, price, deliveryTime }) => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpen = () => setOpenDialog(true);
  const handleClose = () => setOpenDialog(false);

  return (
    <Box >
      <Button
        onClick={handleOpen}
        sx={{
          textTransform: 'none',
          margin: '10px',
          padding: '8px 20px',
          textAlign: 'center',
          transition: '0.5s',
          backgroundSize: '200% auto',
          color: 'white',
          borderRadius: '10px',
          display: 'block',
          border: '0px',
          fontWeight: 700,
          boxShadow: '0px 0px 14px -7px #2b8cb9',
          backgroundImage: 'linear-gradient(45deg, #064D6F 0%, #2b8cb9 51%, #1BB2F8 100%)',
          cursor: 'pointer',
          userSelect: 'none',
          '&:hover': {
            backgroundPosition: 'right center',
            color: '#fff',
            textDecoration: 'none'
          },
          '&:active': {
            transform: 'scale(0.95)'
          }
        }}
      >
        Contact us
      </Button>

      <Dialog  open={openDialog} onClose={handleClose} maxWidth="sm" fullWidth>
        
         
        <DialogContent dividers>
          <ContactUs />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ReserveNow;
